module.exports = __webpack_public_path__ + "static/media/pen-alt_active.4f103637.svg";